<template>
	<!-- loder -->
	<div class="loader_bg">
		<div class="loader"></div>
		<h4 class="loading-title">LOADING...</h4>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
</style>